//60.205.57.44:8011
// let host = 'https://photo-pay-api.zsnews.cn/' //swagger-ui.html#/ 接口swagger地址,合并接口后重新部署,调用视觉中国自己的api，删除utils/request.js文件
// let host = 'http://47.93.198.220:8080/' //swagger-ui.html#/ 接口swagger地址,合并接口后重新部署,调用视觉中国自己的api，删除utils/request.js文件
//let host = 'http://192.168.0.20:8090/'
// let host = 'http://192.168.23.120:8011/'
let host = '/pay/'

//let host = 'http://192.168.0.27:8090/'
//let host = 'http://192.168.1.163:8090/'
export const ipUrl = host;



// WEBPACK FOOTER //
// ./src/service3/index.js